import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getCategorySeoLinks } from "../../state/modules/category/selectors";
import { MIN_SEO_LINKS } from "../constants";
import Pill from "../CategoryHeader/Pill";
import HorizontalScrollListVariant from "../HorizontalScrollList/components/HorizontalScrollListVariant";
import {
  TRANSLATION_KEY_FACETED_NAV_CAROUSEL,
  TRANSLATION_KEY_RELATED_CATEGORIES_CAROUSEL
} from "../HorizontalScrollList/constants";
import { withTranslation } from "../translation";
import styles from "./index.css";

const SecondaryCategorySeoLinks = ({ formatTranslation }) => {
  const { secondarySeoLinks, relatedCategoriesLinks } = useSelector(
    getCategorySeoLinks
  );

  if (secondarySeoLinks.length < MIN_SEO_LINKS) return null;
  const hasSecondaryLinks = secondarySeoLinks.length > 0;
  const hasRelatedLinks = relatedCategoriesLinks.length > 0;

  if (!hasSecondaryLinks && !hasRelatedLinks) return null;

  return (
    <>
      {hasRelatedLinks && (
        <div className={styles.carouselSection}>
          <h2 className={styles.carouselTitle}>
            {formatTranslation("plp_web_related_categories_title")}
          </h2>
          <HorizontalScrollListVariant
            className={styles.relatedCategoriesCarousel}
            ariaLabel={TRANSLATION_KEY_RELATED_CATEGORIES_CAROUSEL}
          >
            {relatedCategoriesLinks.map(({ friendlyName, linkUrl }) => (
              <Pill
                key={friendlyName}
                friendlyName={friendlyName}
                linkUrl={linkUrl}
              />
            ))}
          </HorizontalScrollListVariant>
        </div>
      )}
      {hasSecondaryLinks && (
        <div className={styles.carouselSection}>
          <h2 className={styles.carouselTitle}>
            {formatTranslation("plp_web_faceted_nav_categories_title")}
          </h2>
          <HorizontalScrollListVariant
            className={styles.secondaryCategorySeoLinks}
            ariaLabel={TRANSLATION_KEY_FACETED_NAV_CAROUSEL}
          >
            {secondarySeoLinks.map(({ friendlyName, linkUrl }) => (
              <Pill
                key={friendlyName}
                friendlyName={friendlyName}
                linkUrl={linkUrl}
              />
            ))}
          </HorizontalScrollListVariant>
        </div>
      )}
    </>
  );
};

SecondaryCategorySeoLinks.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(SecondaryCategorySeoLinks);
